import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

// 모든 내장 규칙들을 등록
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

// 커스텀 규칙 등록
extend('positive_integer', {
  validate: value => {
    // 문자열이 들어올 수 있으므로 parseInt로 변환
    const num = typeof value === 'string' ? parseInt(value.replace(/,/g, '')) : value
    // 정수이면서 0보다 큰지 검증
    return Number.isInteger(num) && num > 0
  },
  message: '{_field_}는 0보다 큰 정수를 입력해주세요',
})

extend('min_value', {
  validate: (value, { min }) => {
    const num = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value
    return num >= min
  },
  message: '{_field_}는 {_rule_value_}보다 큰 수를 입력해주세요',
})

extend('max_value', {
  validate: (value, { max }) => {
    const num = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value
    return num <= max
  },
  message: '{_field_}는 {_rule_value_}보다 작은 수를 입력해주세요',
})

const install = (Vue, options = {}) => {
  // ValidationProvider와 ValidationObserver를 전역 컴포넌트로 등록
  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)

  setInteractionMode('lazy')

  // 추가적인 설정이 필요한 경우 여기에 작성
  if (options.customRules) {
    Object.keys(options.customRules).forEach(ruleName => {
      extend(ruleName, options.customRules[ruleName])
    })
  }
}

export default {
  install,
}
